import React, { useState } from "react";
import { Card, RectBtn } from "./../components/General";

import { setUserData } from "../features/slices/userDataSlice";

import { useDispatch } from "react-redux";
import User from "../models/User";

import { TextField } from "@mui/material";
import { PERMISSION } from "../configs/global";
import { useSnackbar } from "notistack";
import { logIn, getAccountByToken } from "../apis/Auth.Api";

const LogIn = () => {
    const { enqueueSnackbar } = useSnackbar();

    const dispatch = useDispatch();
    const [userId, setUserId] = useState("");
    const [password, setPassword] = useState("");
    const [validate, setValidate] = useState("");
    const [loading, setLoading] = useState(false);
    async function attemptLogIn() {
        // Step 1. send userId to server => server returns success and token
        // Step 2. stores token and use token to collect user data
        // Step 3. check if reset is true
        // Step 4. set global user data
        try {
            let logInRes = await logIn({ user_id: userId, password: password });
            if (!logInRes.data.indicator) {
                setValidate(logInRes.data.message);
                return;
            }
            const token = logInRes.data.token;
            localStorage.setItem("token", token);
            // store token and update token state
            const res = await getAccountByToken();
            if (!res.data.indicator) {
                enqueueSnackbar(res.data.message, {
                    variant: "error",
                });
                return;
            }
            let user = new User({
                ...res.data.message,
                token: token,
            });

            if (user.permission === PERMISSION.WEB_SERVER) {
                setValidate("Invalid Account (web-server)");
                return;
            }

            setValidate("");
            dispatch(setUserData(JSON.parse(JSON.stringify(user))));
        } catch (error) {
            console.log("SERVER ERROR |", error);
            enqueueSnackbar("Server Error", { variant: "error" });
        }
    }

    return (
        <div className="page">
            <div className="log-in">
                <Card>
                    <div className="log-in-card">
                        <h4>Log In</h4>

                        <TextField
                            placeholder="User ID"
                            onChange={(e) => {
                                setUserId(e.target.value);
                            }}
                            sx={{ minWidth: "18rem" }}
                            error={validate !== ""}
                        />
                        <TextField
                            placeholder="Password"
                            onChange={(e) => {
                                setPassword(e.target.value);
                            }}
                            sx={{ minWidth: "18rem" }}
                            type="password"
                            error={validate !== ""}
                            onKeyDown={async (e) => {
                                if (e.key === "Enter") {
                                    setLoading(true);
                                    await attemptLogIn();
                                    setLoading(false);
                                }
                            }}
                        />
                        <p className="helperText">{validate}</p>

                        <div className="log-in-btn-wrapper">
                            <RectBtn onClick={attemptLogIn} disable={loading}>
                                <p>Log in</p>
                            </RectBtn>
                        </div>
                    </div>
                </Card>
            </div>
        </div>
    );
};

export default LogIn;
